import styled, { css } from 'styled-components';
import { rem } from '../../../utils';
export const StyledDisabled = css `
  cursor: not-allowed;
  user-select: none;
  opacity: 0.5;
`;
export const StyledInputNumberControllers = styled.div `
  position: absolute;
  top: 1px;
  right: 1px;
  height: calc(100% - 2px);
  display: flex;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  flex-direction: column;
  transition: opacity ${({ theme }) => theme.Transition.Timing.Out};
  border-left: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
`;
export const StyledInputNumberController = styled.button `
  display: flex;
  appearance: none;
  border: none;
  background: transparent;
  cursor: pointer;
  width: ${({ theme }) => rem(theme.Form.InputNumberControllers.Small.width)};
  height: 50%;
  justify-content: center;
  align-items: center;
  transition: background ${({ theme }) => theme.Transition.Timing.Out};

  &:first-child {
    border-top-right-radius: ${({ theme }) => rem(theme.Border.Radius.Medium - theme.Border.Size.Small)};
  }
  &:last-child {
    border-bottom-right-radius: ${({ theme }) => rem(theme.Border.Radius.Medium - theme.Border.Size.Small)};
  }

  &:hover {
    background: ${({ theme }) => theme.Color.Neutrals.Light};
    transition: background ${({ theme }) => theme.Transition.Timing.In};
  }

  &:disabled {
    ${StyledDisabled}
  }
`;
//# sourceMappingURL=InputNumberControllers.style.js.map